import { useEffect, useState } from "react";
import {
  DEMO_SAMPLE_DISPLAY_COUNT,
  pickRandomDemoSamples,
} from "../../config/dashboard/demoAssetsConfig";

/**
 * Random demo thumbs — stable per context, no timer refresh.
 *
 * - Dashboard hero: random 5 on page load, frozen until full reload
 * - Modals / categories: new random 5 each time opened (resetKey / enabled)
 *
 * Only 5 CDN thumb URLs are loaded at a time (not the full pool).
 */
export function useRandomDemoSamples(pool, options = {}) {
  const { count = DEMO_SAMPLE_DISPLAY_COUNT, enabled = true, resetKey = "" } = options;

  const [samples, setSamples] = useState(() =>
    enabled && pool?.length ? pickRandomDemoSamples(pool, count) : []
  );

  useEffect(() => {
    if (!enabled || !pool?.length) {
      setSamples((prev) => (prev.length === 0 ? prev : []));
      return;
    }
    setSamples(pickRandomDemoSamples(pool, count));
  }, [pool, count, enabled, resetKey]);

  return samples;
}